<script>
  import { tick } from 'svelte'
  import { onMount } from 'svelte'
  import { createPostRequest } from '../../src/create_request'
  import { focus, countries } from '../../src/utils'
  import { cart } from '../../src/data_storage.js'
  cart.useLocalStorage()

  import { _, locale, locales } from 'svelte-i18n'
  import InputField from '../inputs/input_field.svelte'

  export let shop
  export let order
  export let signedIn
  export let done_handler

  let firstName = ""
  let lastName = ""
  let street1 = ""
  let street2 = ""
  let city = ""
  let zipcode = ""
  let state = ""
  let country = ""
  let phone = ""
  let billingSameAsShipping = false
  let firstNameB = ""
  let lastNameB = ""
  let street1B = ""
  let street2B = ""
  let cityB = ""
  let zipcodeB = ""
  let stateB = ""
  let countryB = ""
  let phoneB = ""

  let errors = null

  function handleSubmit() {
    const address = {
      first_name: firstName,
      last_name: lastName,
      street1: street1,
      street2: street2,
      city: city,
      zipcode: zipcode,
      country: country,
      state: state,
      phone: phone
    }

    let addressB = {
      first_name: firstNameB,
      last_name: lastNameB,
      street1: street1B,
      street2: street2B,
      city: cityB,
      zipcode: zipcodeB,
      country: countryB,
      state: stateB,
      phone: phoneB
    }

    if (billingSameAsShipping) {
      addressB = address
      firstNameB = firstName
      lastNameB = lastName
      street1B = street1
      street2B = street2
      cityB = city
      zipcodeB = zipcode
      countryB = country
      stateB = state
      phoneB = phone
    }

    saveSettings()

    console.log("ADDRESS:")
    console.log(address)

    let updateOrderData = {
                            shipping_address_attributes: address,
                            billing_address_attributes: addressB,
                            items: $cart[shop.id].items.map((kich) => kich.id)
                          }
    let method = $cart[shop.id].shipping_address ? 'PUT' : 'POST'
    if (order && order.id) {
      method = 'PUT'
      updateOrderData = {
        shipping_address_attributes: address,
        billing_address_attributes: addressB
      }
    }

    fetch(createPostRequest('/cart/checkout_address.json',
                        method,
                        JSON.stringify({
                          order_id: order.id,
                          order: updateOrderData,
                          slug: shop.slug
                        })))
      .then(response => response.json())
      .then(data => {
        console.log('checkout_address ' + shop.slug)
        console.log(data)
        if (data.errors) {
          // alert(data.errors.email)
          errors = data.errors
        } else if (data.id) {
          if (done_handler) {
            done_handler(data)
          }
        } else {
          error = "Something went wrong, try again later."
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  function mountFromData(data, pushState = false) {
    console.log('checkoutAddres mountFromData' + shop.slug)
    console.log(data)
  }

  function loadSettings() {
    console.log('checkout_address loadSettings')
    console.log($cart[shop.id].shipping_address)

    if ($cart[shop.id].shipping_address) {
      const address = $cart[shop.id].shipping_address
      firstName = address.first_name
      lastName = address.last_name
      street1 = address.street1
      street2 = address.street2
      city = address.city
      zipcode = address.zipcode
      country = address.country
      state = address.state
      phone = address.phone
    }

    if ($cart[shop.id].billing_address) {
      const address = $cart[shop.id].billing_address
      firstNameB = address.first_name
      lastNameB = address.last_name
      street1B = address.street1
      street2B = address.street2
      cityB = address.city
      zipcodeB = address.zipcode
      countryB = address.country
      stateB = address.state
      phoneB = address.phone
    }

    if (firstName === firstNameB && lastName === lastNameB && street1 === street1B && street2 === street2B && city === cityB && zipcode === zipcodeB && country === countryB && state === stateB && phone === phoneB) {
      billingSameAsShipping = true
    }
  }

  function saveSettings() {
    console.log('checkout_address saveSettings ')
    let address = {
      first_name: firstName,
      last_name: lastName,
      street1: street1,
      street2: street2,
      city: city,
      zipcode: zipcode,
      country: country,
      state: state,
      phone: phone
    }
    $cart[shop.id].shipping_address = address

    let addressB = {
      first_name: firstNameB,
      last_name: lastNameB,
      street1: street1B,
      street2: street2B,
      city: cityB,
      zipcode: zipcodeB,
      country: countryB,
      state: stateB,
      phone: phoneB
    }
    $cart[shop.id].billing_address = addressB
  }


  onMount(async () => {
    console.log("checkout_address onMount " + shop.slug)
    loadSettings()
    if (!country) {
      // set default country according to locale
      let cId = $locale.split('-')[1]
      console.log("cId: " + cId)
      let cntry = countries.find((c) => c.value === cId)
      if (cntry) {
        country = cntry.text
      }
    }
  })
</script>

<style>
</style>

<div class="frame mt-3 mx-4">
  <form id="address-form" on:submit|preventDefault={handleSubmit}>
    <div class="flex flex-col">
      <div class="shipping flex flex-col gap-4 mt-3">
        <div class="text-lg">{$_('please_enter_shipping')}</div>
        <div class="address-field">
          <InputField class="border-2 dark:border-black dark:bg-black" name="shipping_address[first_name]" type="text" title="First Name" bind:value={firstName} use={focus}/>
        </div>
        <div class="address-field">
          <InputField class="border-2 dark:border-black dark:bg-black" name="shipping_address[last_name]" type="text" title="Last Name" bind:value={lastName}/>
        </div>
        <div class="address-field">
          <InputField class="border-2 dark:border-black dark:bg-black" name="shipping_address[street1_name]" type="text" title="Street" bind:value={street1}/>
        </div>
        <div class="address-field">
          <InputField class="border-2 dark:border-black dark:bg-black" name="shipping_address[street2_name]" type="text" title="Building/floor" bind:value={street2}/>
        </div>
        <div class="address-field">
          <InputField class="border-2 dark:border-black dark:bg-black" name="shipping_address[zipcode_name]" type="text" title="Zip or postcode" bind:value={zipcode}/>
        </div>
        <div class="address-field">
          <InputField class="border-2 dark:border-black dark:bg-black" name="shipping_address[city_name]" type="text" title="City" bind:value={city}/>
        </div>
        <div class="address-field">
          <InputField class="border-2 dark:border-black dark:bg-black" name="shipping_address[country]" type="select" title="Country" bind:value={country} options={countries}/>
        </div>
        <div class="address-field">
          <InputField class="border-2 dark:border-black dark:bg-black" name="shipping_address[state]" type="text" title="State" bind:value={state}/>
        </div>
        <div class="address-field">
          <InputField class="border-2 dark:border-black dark:bg-black" name="shipping_address[phone]" type="text" title="Phone" bind:value={phone}/>
        </div>
      </div>

      {#if billingSameAsShipping}
        <div class="flex flex-col gap-2 mt-3">
          <label for="billing-same-as-shipping">{$_('billing_same_as_shipping')}</label>
          <input id="billing-same-as-shipping" name="billing-same-as-shipping" type="checkbox" checked=true on:click={()=>{billingSameAsShipping=false}}/>
        </div>
      {:else}
        <div class="billing flex flex-col gap-4 mt-3">
          <label for="billing-same-as-shipping">{$_('billing_same_as_shipping')}</label>
          <input id="billing-same-as-shipping" name="billing-same-as-shipping" type="checkbox" on:click={()=>{billingSameAsShipping=true}}/>
          <div class="mt-4 text-lg">{$_('please_enter_billing')}</div>
          <div class="address-field">
            <InputField class="border-2 dark:border-black dark:bg-black" name="billing_address[first_name]" type="text" title="First Name" bind:value={firstNameB} use={focus}/>
          </div>
          <div class="address-field">
            <InputField class="border-2 dark:border-black dark:bg-black" name="billing_address[last_name]" type="text" title="Last Name" bind:value={lastNameB}/>
          </div>
          <div class="address-field">
            <InputField class="border-2 dark:border-black dark:bg-black" name="billing_address[street1_name]" type="text" title="Street" bind:value={street1B}/>
          </div>
          <div class="address-field">
            <InputField class="border-2 dark:border-black dark:bg-black" name="billing_address[street2_name]" type="text" title="Building/floor" bind:value={street2B}/>
          </div>
          <div class="address-field">
            <InputField class="border-2 dark:border-black dark:bg-black" name="billing_address[zipcode_name]" type="text" title="Zip or postcode" bind:value={zipcodeB}/>
          </div>
          <div class="address-field">
            <InputField class="border-2 dark:border-black dark:bg-black" name="billing_address[city_name]" type="text" title="City" bind:value={cityB}/>
          </div>
          <div class="address-field">
            <InputField class="border-2 dark:border-black dark:bg-black" name="billing_address[country]" type="select" title="Country" bind:value={countryB} options={countries}/>
          </div>
          <div class="address-field">
            <InputField class="border-2 dark:border-black dark:bg-black" name="billing_address[state]" type="text" title="State" bind:value={stateB}/>
          </div>
          <div class="address-field">
            <InputField class="border-2 dark:border-black dark:bg-black" name="billing_address[phone]" type="text" title="Phone" bind:value={phoneB}/>
          </div>
        </div>
      {/if}
    </div>
    {#if errors}
      <div class="mt-3 bg-red-100 flex flex-col items-center justify-center">
        <div>{#if (errors['email'])}{$_('email')} {errors['email']}{/if}</div>
        <div>{#if (errors['password'])}{$_('password')} {errors['password']}{/if}</div>
        <div>{#if (errors['base'])}{errors['base']}{/if}</div>
      </div>
    {/if}
    <div class="my-3 flex flex-row justify-center items-center">
      <button id="continue-address" class="btn" type="submit">{$_('continue')}</button>
    </div>
  </form>
</div>
